import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// ---- action / redux
import { actModalChange, actModalIsOk, actResetModal } from '../../../actions/modal';
import ModalSupportOption from '../../../components/SupportComponents/Modal/ModalOption';
import haveNotDataFind from '../../../utils/Img/not_data_find.png'
import {
    createNotificationTemplate,
    getNotificationTemplates,
    updateNotificationTemplate,
} from '../../../api/other/notificationTemplate';
import './notificationForm.css'

function NotificationForm() {
    const dispatch = useDispatch();
    const auth = useSelector(state => state.auth);
    const token = useSelector(state => state.token);

    const role = auth?.user?.role;
    const canManageTemplate = typeof role === 'number' && role !== 0 && role !== 4;

    const customNotification = useMemo(() => ({
        category: "other",
        name: "",
        name2: "",
        name3: "",
        key: "",
        fontSize: 25,
        content: Array.from({ length: 8 }, () => ({
            text: "",
            edit: false,
        }))
    }), []);

    const [templates, setTemplates] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectRow, setSelectRow] = useState(0);
    const [keySearch, setKeySearch] = useState("");
    const [listSuggest, setListSuggest] = useState([]);

    useEffect(() => {
        document.title = 'Notification Form';
    }, []);

    useEffect(() => {
        if (!token) return;
        loadTemplateData();
    }, [token]);

    async function loadTemplateData() {
        try {
            const res = await getNotificationTemplates(token);
            const list = res.data?.templates || [];
            setTemplates(list);

            const listCategory = [...new Set(list.map(item => item.category || 'other'))];
            setCategories(listCategory);

            if (selectRow >= listCategory.length) {
                setSelectRow(0);
            }
        } catch (error) {
            alert(error?.response?.data?.msg || 'Load template failed');
        }
    }

    function removeAccents(str = "") {
        return str
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/đ/g, 'd').replace(/Đ/g, 'D');
    }

    const selectedCategory = categories[selectRow] || "other";

    const templatesInCategory = useMemo(() => {
        return templates.filter(item => (item.category || 'other') === selectedCategory);
    }, [templates, selectedCategory]);

    function renderListRow() {
        let result = [];

        categories.forEach((item, index) => {
            result.push(<div style={{ 
                padding:'36px', 
                fontSize:'1.3rem', 
                background: selectRow === index ? "aqua" : "",
                border:'1px solid',
                cursor: 'pointer' }}
                onClick={()=>setSelectRow(index)}
            >
                {item.toUpperCase()}
            </div>)
        });

        return result;
    }

    function renderListColum(dataRender) {
        let result =[];

        dataRender.forEach((item, index) => {
            result.push(<div style={{
                            padding:'12px', 
                            fontSize:'1.3rem', 
                            textAlign:'left', 
                            fontWeight:'600', 
                            cursor:'pointer',
                            borderBottom:'1px solid',
                            marginLeft:'24px',
                        }}
                        onClick={()=> openModalShowContent(item)}
                        >
                            <div style={{
                                fontSize:'1.3rem', 
                            }}> *Eng: {item.name.toUpperCase()}</div>
                            <div style={{
                                fontSize:'1.3rem', 
                            }}> *Jap: {item.name2.toUpperCase()}</div>
                            <div style={{
                                fontSize:'1.3rem', 
                            }}> *Vie: {item.name3.toUpperCase()}</div>
                        </div>)
        })

        return result;
    }

    function printDiv(divName) {
        const printContents = document.getElementById(divName).innerHTML;
        const printWindow = window.open('', '_blank');

        if (printWindow) {
            printWindow.document.open();
            const doc = printWindow.document;

            const html = `
                <html>
                <head>
                    <title>In nội dung</title>
                    <style>
                        body { padding: 10px; font-family: Arial, sans-serif; }
                    </style>
                </head>
                <body>
                    ${printContents}
                    <script>
                        window.onload = function() {
                            window.print();
                            window.close();
                        };
                    </script>
                </body>
                </html>
            `;

            doc.write(html); // vẫn dùng write ở đây nhưng có thể dễ migrate
        }
    }

    async function onSaveTemplate(payload) {
        try {
            if (!canManageTemplate) {
                alert('Permission denied.');
                return false;
            }

            if (payload._id) {
                await updateNotificationTemplate(payload._id, payload, token);
            } else {
                await createNotificationTemplate(payload, token);
            }

            await loadTemplateData();
            showListSuggest(keySearch);
            return true;
        } catch (error) {
            alert(error?.response?.data?.msg || 'Save template failed');
            return false;
        }
    }

    function openModalShowContent(data) {
        const changeModal = actModalChange("centered", data.name, 
        <ModalSupportOption
            featureSupport1={() => closeModal()}
           featureSupport2={printDiv}
            type={10}
            itemOption={{
                data,
                canManageTemplate,
                onSaveTemplate,
                categories,
            }}
        />, "", "", 'xl');
        dispatch(changeModal);

        //ModalTableComponent
        const actOpen = actModalIsOk();
        dispatch(actOpen);
    }

    function showListSuggest(value) {
        const newListSuggest = [];

        setKeySearch(value);

        if (value.trim() === "") {
            setListSuggest([]);
            return;
        }

        const keySearchNormalize = removeAccents(value.toLowerCase());

        templates.forEach(item => {
            const contentText = (item.content || []).map(row => row.text || '').join(' ');
            const isFound =
                removeAccents((item.name || '').toLowerCase()).includes(keySearchNormalize) ||
                removeAccents((item.name2 || '').toLowerCase()).includes(keySearchNormalize) ||
                removeAccents((item.name3 || '').toLowerCase()).includes(keySearchNormalize) ||
                removeAccents((item.category || '').toLowerCase()).includes(keySearchNormalize) ||
                removeAccents(contentText.toLowerCase()).includes(keySearchNormalize);

            if (isFound) {
                newListSuggest.push(item)
            }
        });

        setListSuggest(newListSuggest);
    }

    // Modal
    function closeModal() {
        const closeModal = actResetModal();
        dispatch(closeModal);
    }

    return (<div >
         <h1 className="no-print">Announcement Form</h1>
         <div>
            <label style={{fontSize:'1.3rem'}}>
                Input key search:
                <input className='ml-2'
                    value={keySearch}
                    onChange = { e => showListSuggest(e.target.value)}
                ></input>
                 {canManageTemplate &&<button
                    className='btn btn-primary ml-2'
                    style={{alignContent: 'center'}}
                    disabled={!canManageTemplate}
                    onClick={()=>openModalShowContent(customNotification)}
                >Make Announcement</button> }
                {/* {!canManageTemplate && <span className='ml-2 text-danger'>Role 0/4 cannot create or update template.</span>} */}
            </label>
         </div>
         {
            keySearch === "" &&
         <div className='d-flex'>
            <div style={{ width:'150px'}}>
                {renderListRow()}
            </div>
            <div style={{ width:'24px', marginTop: (selectRow * 95) + "px"}}>
                <div className="info">
                    <span className="arrow-right"></span>
                </div>
            </div>
            <div style={{ background: '#8080803b', width:'100%'}}>
                {templatesInCategory.length > 0 && renderListColum(templatesInCategory)}
            </div>
         </div> }

         {(listSuggest.length > 0 && keySearch !== "") && 
         <div style={{ background: '#8080803b', width:'180%', margin: 'auto'}}>{renderListColum(listSuggest)}</div>}
         {(listSuggest.length === 0 && keySearch !== "") && <div 
                style={{
                    // width: '300px', 
                    background: 'azure', 
                    borderRadius: '25px', 
                    padding: '12px',
                    height: '100%'
                }}>
             <h1>Have not data find</h1>
             <img src={haveNotDataFind} alt="have not data" width={300}/>
         </div>
         }
    </div>)
}

export default NotificationForm;
